/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { UrlFieldItemEdit } from "./edit-item";

const UrlFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <UrlFieldItemEdit />
        </FieldListEditWrapper>
    );
};
UrlFieldEdit.displayNAme = "UrlFieldEdit";
export { UrlFieldEdit };
